/**
 * Upload Dashboard Component
 * Main layout for file upload feature with routing
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, Container, Grid } from '@mui/material';
import ModernHeader from '../common/ModernHeader';
import BatchCreation from './BatchCreation';
import FileUpload from './FileUpload';
import BatchList from './BatchList';
import BatchDetails from './BatchDetails';
import ActivityFeed from './ActivityFeed';
import GlobalStats from './GlobalStats';

const UploadDashboard: React.FC = () => {
  console.log('🔍 UploadDashboard component rendered');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header with navigation */}
      <ModernHeader />
      
      {/* Main content */}
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
      <Routes>
        {/* Create new batch */}
        <Route path="/create" element={<BatchCreation />} />
        
        {/* Upload files to batch */}
        <Route path="/files/:batchId" element={<FileUpload />} />
        
        {/* View batch details */}
        <Route path="/batch/:batchId" element={<BatchDetails />} />
        
        {/* List all batches (main view) */}
        <Route
          path="/batches"
          element={
            <Box>
              {/* Stats */}
              <Box sx={{ mb: 4 }}>
                <GlobalStats />
              </Box>
              
              {/* Main Content */}
              <Grid container spacing={3}>
                {/* Batch List */}
                <Grid item xs={12} lg={9}>
                  <BatchList />
                </Grid>
                
                {/* Activity Feed */}
                <Grid item xs={12} lg={3}>
                  <ActivityFeed />
                </Grid>
              </Grid>
            </Box>
          }
        />
        
        {/* Default redirect to batches list */}
        <Route path="/" element={<Navigate to="/upload/batches" replace />} />
        <Route path="*" element={<Navigate to="/upload/batches" replace />} />
      </Routes>
      </Container>
    </Box>
  );
};

export default UploadDashboard;

